import TablePoints from './TablePoints'

export default TablePoints;